module.exports = __webpack_public_path__ + "988b24a1852d415735855bb3212f0ef0-GetTheApp-Transparent.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/homeHeader/assets/GetTheApp-Transparent.png
// module id = 551
// module chunks = 0